export default "__VITE_ASSET__62b39a75__"